export const MobileFilters = (function () {
	'use strict';

	let $filterButton, $notice;

	function init() {
		$filterButton = $('[data-filter-target]');
		$notice = $('.woocommerce-notices-wrapper .woocommerce-message');

		if ($notice.length > 0) {
			$('.je_single_add_to_cart_button').addClass('added');
		}

		events();
	}

	function events() {
		if(!$filterButton) return;
		$filterButton.each(function () {
			let $this = $(this);
			let $filterTarget = $('#' + $this.data('filter-target'));
			let $filterClose = $('[data-filter-close]');
			let $filterBack = $('[data-filter-back]');
			let $filterItems = $filterTarget.find('.products-sidebar__filter-item');
			let $filterTitle = $filterTarget.find('.products-sidebar__filter-title h2');
			let $sort = $filterTarget.find(
				'.products-sidebar__filter-sort select option'
			);
	
			$filterClose.on('click', function () {
				$filterTarget.removeClass('active');
				$filterItems.removeClass('active');
	
				$('body').css('overflow', '');
			});
	
			$filterBack.on('click', function () {
				$filterItems.removeClass('active');
				$filterBack.css('display', '');
				$filterTitle.find('span').html('');
				$filterTitle.find('svg').show();
			});
	
			$this.on('click', function () {
				$filterTarget.addClass('active');
				$filterTarget.css('height', window.innerHeight);
				$('body').css('overflow', 'hidden');
				console.log('??', window.innerHeight);
				$('body').on('resize', function () {
					$filterTarget.css('height', window.innerHeight);
					console.log('?? resized', window.innerHeight);
				});
			});
	
			if ($sort.length > 0) {
				setTimeout(() => {
					renderSelect($sort);
				}, 1000);
				return;
			}
	
			$filterItems.each(function () {
				let $item = $(this);
				let $itemSubTitle = $item
					.find('[data-filter-sub-title]')
					.data('filter-sub-title');
				let $itemButton = $item.find('button');
				// console.log($item, $itemSubTitle);
	
				$itemButton.on('click', function () {
					$filterBack.css('display', 'block');
					$filterTitle.find('svg').hide();
					$filterTitle.find('span').html(': ' + $itemSubTitle);
					$(this).parent().addClass('active');
				});
			});
		});
	}

	function renderSelect() {
		let $selectContainer = $('.products-sidebar__filter-sort');
		let $newSelect = $selectContainer.find('.products-sidebar__filter-body');
		let $select = $selectContainer.find('select');
		let $options = $select.find('option');

		// $('.facetwp-sort').append(newSelect);

		$options.clone().each(function () {
			let $optionName = $(this).text();
			$newSelect.append(
				'<li class="products-sidebar__filter-item"><div class="facetwp-facet facetwp-type-checkboxes"><div class="facetwp-checkbox">' +
					$optionName +
					'</div></div></li>'
			);

			$(this).on('click', function () {
				// console.log($(this), '?');
				$select.val($(this).val()).change();
				$newSelect.addClass('active').siblings().removeClass('active');
			});
		});

		$select.hide();

		$('.facetwp-facet').on('click', function () {
			// console.log('here?');
			$(this).parent().addClass('active').siblings().removeClass('active');
			$(this)
				.parent()
				.siblings()
				.find('.facetwp-checkbox')
				.removeClass('checked');
		});

		$(this).on('click', function () {
			let $list = $('.products-sidebar__filter-item');
			!$list.hasClass('active')
				? $list.addClass('active')
				: $list.removeClass('active');
		});
	}

	return {
		init: init,
	};
})();
